import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-aix-uidw",
  templateUrl: "./aix-uidw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AIxUIDWComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.AIxUIDW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, "Customer Name", "Project Name"];
}

